import fetch from "cross-fetch";
import { CMS_API_URL } from "../../config";
import { shouldFetchCollections } from "./selectors";
import * as ActionCreators from "./creators";
import { selectCollection } from "../home_ui/creators";
import { fetchSuggestionsInCollection } from "../circle_suggestion/operations";
import { fetchCirclesInCollection } from "../circles_in_collection/operations";

export function fetchCircleCollections(collectionKey = undefined, is_published=true) {
  return function(dispatch, getState) {
    if (!shouldFetchCollections(getState())) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingCircleCollections());
    return fetch(`${CMS_API_URL}/circlecollections?is_published=${is_published}`)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingCircleCollections(error));
        }
      )
      .then(response => {
        // const state = getState();
        // debugger
        // if (!state.circle_collection.list.length || state.circle_collection.list[0].key=='husqvarna'){
          // let collectionKey = response[0].key;
          // if (selectedCollection) {
          //   collectionKey = selectedCollection;
          // }
          dispatch(selectCollection(collectionKey));
          dispatch(fetchSuggestionsInCollection(collectionKey, 4, 0, true));
          dispatch(fetchCirclesInCollection(collectionKey, 4, 0, true));
        // }
        dispatch(ActionCreators.fetchedCircleCollections(response));
      });
  };
}
